import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsGetSurveys,
  type IParamsCreateSurvey,
  type IParamsEnrolmentSurvey,
  type IResponseCreateSurvey,
  type IResponseEnrolmentSurvey,
  type IResponseGetSurveys,
  type IResponseGetSurvey,
  type IResponseFullSurvey,
  type IResponseGetSurveyExecutions,
} from './types'

class Api {
  createSurvey(params: IParamsCreateSurvey): Promise<AxiosResponse<IResponseCreateSurvey>> {
    return baseApi.post('survey/api/surveys', params)
  }

  getSurveys(
    params?: IParamsGetSurveys,
    options?: Omit<AxiosOptions, 'params'>
  ): Promise<AxiosResponse<IResponseGetSurveys>> {
    return baseApi.get('survey/api/surveys', { ...options, params })
  }

  deleteSurvey(id: number): Promise<AxiosResponse<void>> {
    return baseApi.delete(`survey/api/surveys/${id}`)
  }

  activateSurvey(
    id: number,
    params: { is_active: boolean }
  ): Promise<AxiosResponse<IResponseGetSurvey>> {
    return baseApi.put(`survey/api/surveys/${id}/status`, params)
  }

  getSurvey(id: number): Promise<AxiosResponse<IResponseFullSurvey>> {
    return baseApi.get(`survey/api/surveys/${id}`)
  }

  updateSurvey(
    id: number,
    params: IParamsCreateSurvey
  ): Promise<AxiosResponse<IResponseCreateSurvey>> {
    return baseApi.put(`survey/api/surveys/${id}`, params)
  }

  enrolmentSurvey({
    id,
    data,
  }: IParamsEnrolmentSurvey): Promise<AxiosResponse<IResponseEnrolmentSurvey>> {
    return baseApi.post(`survey/api/surveys/${id}/enroll`, data)
  }

  getContactSurveyExecutions(
    contactId: number
  ): Promise<AxiosResponse<IResponseGetSurveyExecutions>> {
    return baseApi.get(`survey/api/contacts/${contactId}/executions`)
  }
}

export const SurveysApi = new Api()
